import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';
import moment from 'moment';

import React, { Component } from 'react';

import { DiversityTable, PageName } from 'client/bundles/types';

import './index.css';

import MenuSection from 'client/components/menu-section';

const b = cn('diversity');
const bPageTitle = cn('page-title');

interface Props {
    title: string;
    sectionTitle: string;
    pageName: PageName;
    table: DiversityTable;
}

class Diversity extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { title, pageName, table } = this.props;
        const { lang } = this.context;

        return (
            <div className={b()}>
                <h1 className={bPageTitle(lang === 'ru' ? { type: 'border' } : '')}>{title}</h1>

                {

                    /* TODO разобраться с подменю IR-571 */
                    lang === 'en' && <MenuSection type="governance" pageName={pageName} />
                }

                <div className={b('content')}>
                    <table className={b('table')}>
                        <caption><strong>{table.caption}</strong></caption>
                        <thead>
                            <tr>
                                <th>As of</th>
                                <td colSpan={4}>
                                    {moment(table.date).format('MM/DD/YYYY')}
                                </td>
                            </tr>
                            <tr>
                                <th>Country of Principal Executive Offices:</th>
                                <td colSpan={4}>{table.country}</td>
                            </tr>
                            <tr>
                                <th>Foreign Private Issuer</th>
                                <td colSpan={4}>{table.issuer}</td>
                            </tr>
                            <tr>
                                <th>Disclosure Prohibited under Home Country Law</th>
                                <td colSpan={4}>{table.disclosure}</td>
                            </tr>
                            <tr>
                                <th>Total Number of Directors</th>
                                <td colSpan={4}>{table.count}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>&nbsp;</th>
                                <td><strong>Female</strong></td>
                                <td><strong>Male</strong></td>
                                <td><strong>Non-Binary</strong></td>
                                <td><strong>Did Not Disclose Gender</strong></td>
                            </tr>
                            <tr>
                                <th><strong>Part I: Gender Identity</strong></th>
                                <td colSpan={4}>&nbsp;</td>
                            </tr>
                            <tr>
                                <th>Directors</th>
                                <td>{table.identity.female}</td>
                                <td>{table.identity.male}</td>
                                <td>{table.identity.nonbinary}</td>
                                <td>{table.identity.dnd}</td>
                            </tr>
                            <tr>
                                <th><strong>Part II: Demographic Background</strong></th>
                                <td colSpan={4}>&nbsp;</td>
                            </tr>
                            <tr>
                                <th>Underrepresented Individual in Home Country Jurisdiction</th>
                                <td colSpan={4}>{table.demographic.underrepresented}</td>
                            </tr>
                            <tr>
                                <th>LGBTQ+</th>
                                <td colSpan={4}>{table.demographic.lgbtq}</td>
                            </tr>
                            <tr>
                                <th>Did Not Disclose Demographic Background</th>
                                <td colSpan={4}>{table.demographic.dnd}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

}

export default Diversity;
